import { runInAction } from 'mobx'
import type { FunctionComponent } from 'react'
import { memo, Suspense } from 'react'
import type { BasePagesEnum } from '../services'
import { getLogger, OmniaComponents, Services } from '../services'

const logger = getLogger('App')

export const PageWrapper: FunctionComponent<{ page: keyof BasePagesEnum; overrideElement?: FunctionComponent }> = memo(
    props => {
        // const occConfig = useOccConfig()

        runInAction(() => {
            const previousPage = Services.NavigationService.getCurrentPage()
            if (previousPage !== props.page) {
                Services.NavigationService.setPreviousPage(Services.NavigationService.getCurrentPage())
            }
            Services.NavigationService.setCurrentPage(props.page)

            // if (previousPage === undefined && props.page !== PagesEnum.Cinema) {
            //     logger.value.debug(
            //         'Detected initial page load and not on a cinema page. Loading default custom film actions.'
            //     )

            //     // Initially load film actions using no site - a site id is only required for Cinema pages, which override setting this data.
            //     void getCustomFilmActions(undefined).then(actions => {
            //         logger.value.debug('Setting custom film actions', actions)
            //         runInAction(() => {
            //             occConfig.film.customActions = actions
            //         })
            //     })
            // }
        })

        // useAbandonOrder()

        logger.value.debug('PageWrapper', props.page.toString(), Date.now() - window.loadMs)

        const PageElement = props?.overrideElement ?? Services.NavigationService.Pages[props.page].component
        return (
            <Suspense fallback={OmniaComponents.Loading ? <OmniaComponents.Loading /> : <></>}>
                <PageElement />
            </Suspense>
        )
    }
)
